/* ===== 1. Основные компоненты react ===== */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

/* ===== 2. Основной файл стилей ===== */
import "./styles/main.scss";

/* ===== 3. Основной файл верстки ===== */
import App from './App';

/* <--- Установка --vh для мобильных экранов ---> */
const setVh = () => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
};

/* <--- Вызов один раз на старте ---> */
setVh();

/* <--- Обновляем при изменении размера окна ---> */
window.addEventListener('resize', setVh);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);